<template>
  <div>

    <v-dialog
        v-model="isZoomOut"
        width="auto"
        class="pa-10"
    >
      <template v-slot:activator="{ on, attrs }">

        <v-img :src="imgurl" :style="{
      width: '100px',
      height:'100px'
    }"

               v-bind="attrs"
               v-on="on"
               class="ml-10"
        >

        </v-img>
      </template>

      <v-card>

        <!--      <v-img :src="imgurl" width="400" height="400"></v-img>-->
        <img :src="imgurl"/>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "imgbox",
  props: ["imgurl"],
  components: {},
  data() {
    return {
      isZoomOut: false
    }
  },
  methods: {},
  mounted() {

  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>